import { render, staticRenderFns } from "./CommonSlideImage.vue?vue&type=template&id=4c8fc192&"
import script from "./CommonSlideImage.vue?vue&type=script&lang=js&"
export * from "./CommonSlideImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports